import { lazy } from "react";

const Services = lazy(() => import("../pages/services/Services"));
const NewService = lazy(() => import("../pages/services/NewService"));
const ServicesView = lazy(() => import("../pages/services/ServicesView"));
const EditService = lazy(() => import("../pages/services/EditService"));

export const servicesRoutes = [
  {
    path: "/services",
    component: Services,
  },
  {
    path: "/services/new",
    component: NewService,
  },
  {
    path: "/services/:id",
    component: ServicesView,
  },
  {
    path: "/services/edit/:id",
    component: EditService,
  },
];
